import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Owner = {
  id: null,
  first_name: '',
  last_name: '',
  middle_name: '',
}

const OwnerResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'business/owners/list/',
  },
  details: {
    method: 'GET',
    url: 'business/owners/detail/{id}/',
  },
  history: {
    method: 'GET',
    url: 'business/capital/list/',
  },
  create: {
    method: 'POST',
    url: 'business/owners/create/',
  },
  update: {
    method: 'PUT',
    url: 'business/owners/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'business/owners/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,

    fetching: false,
    model: ut.deepClone(Owner),

    saving: false,
    deleting: {},

    fetchingHistory: false,
    history: null,
  },

  getters: {
    getOwner: (state) => (id) => state.data?.results?.find(m => m.id === id),
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Owner), ...data}
    },

    setHistory(state, data) {
      state.history = data
    },
  },

  actions: {
    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = OwnerResource
                            .list(ut.objFilter(filters))
                            .then((response) => {
                              commit('setItems', response.body)
                            })
                            .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = OwnerResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    fetchHistory({state, commit}, filters = {}) {
      if (!state.fetchingHistory) {
        commit('setHistory', null)
        state.fetchingHistory = OwnerResource
          .history(ut.objFilter(filters))
          .then((response) => {
            commit('setHistory', response.body)
          })
          .finally(() => state.fetchingHistory = false)
      }

      return state.fetchingHistory
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = OwnerResource.update({id: state.model.id}, state.model)
      } else {
        promise = OwnerResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return OwnerResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
